import { GenericTableColumns, PromptStackItem } from '../swivl-lib'

export enum NodeType {
  Array = 'array',
  Action = 'action',
  Analytics = 'analytics',
  Buttons = 'buttons',
  Carousel = 'carousel',
  Command = 'command',
  Continue = 'continue',
  CRM = 'crm',
  DateAndTime = 'dateAndTime',
  Email = 'email',
  Experiment = 'experiment',
  ExperimentEnd = 'experimentEnd',
  Escalation = 'escalation',
  Finish = 'finish',
  Hubspot = 'hubspot',
  Input = 'input',
  Increment = 'increment',
  Logic = 'logic',
  Media = 'media',
  Message = 'message',
  MultiSelect = 'multiSelect',
  NLP = 'nlp',
  Notification = 'notification',
  OpenOrClose = 'openOrClose',
  PastMessages = 'pastMessages',
  ProfileCollect = 'profileCollect',
  Quest = 'quest',
  Random = 'random',
  Route = 'route',
  RouterStart = 'routerStart',
  Save = 'save',
  Sentiment = 'sentiment',
  Slack = 'slack',
  SMS = 'SMS',
  SMSGroup = 'SMSGroup',
  Start = 'start',
  URL = 'url',
  // StoreInfo            = "storeInfo"    ,
  StoreLead = 'storeLead',
  StoreFinderLookup = 'storeFinderLookup',
  SpacePicker = 'spacePicker',
  StoreAccessCode = 'storeAccessCode',
  StoreGetTenant = 'storeGetTenant',
  TypingIndicator = 'typingIndicator',
  TableSaveRow = 'tableSaveRow',

  Voice = 'voice',
  LLM = 'llm'
}

export interface NodeInterface {
  id: string
  type: NodeType
  [key: string]: any
}

export interface NodeData_TableSaveRowNode extends NodeInterface {
  id: string
  type: NodeType.TableSaveRow
  table?: string
  onSaveGoto?: string
  onMissingParamsGoto?: string
  update?: boolean
  data: { [Property in keyof Partial<GenericTableColumns>]: string }
}

export interface NodeData_Array extends NodeInterface {
  id: string
  type: NodeType.Array
  action: 'ADD' | 'REMOVE' | 'CLEAR' | 'HAS' | 'COUNT'
  variableId?: string
  goto?: string
  hasNotGoto?: string
  greaterThanGoto?: string
  lessThanGoto?: string
  equalToGoto?: string
  values?: string
  count?: number
}

export interface NodeData_Increment extends NodeInterface {
  id: string
  type: NodeType.Increment
  variableId?: string
  goto?: string
  amount: number
}

export interface NodeData_StoreFinderLookup extends NodeInterface {
  id: string
  type: NodeType.StoreFinderLookup
  storeFoundGoto: string
  storeNotSelectedGoto: string
  missingParamsGoto: string
  useURL: boolean
  usePostalCode: boolean
  useFMSId: boolean
  filterStores?: boolean
  filterVariableId?: string
}

export interface NodeData_LLM extends NodeInterface {
  id: string
  type: NodeType.LLM
  prompts: PromptStackItem[]
  goto?: string
  numberOfTokensToReturn: number
}

export enum VoiceNodeCommandType {
  // PAUSE = 'pause',
  HANGUP = 'hangup',
  FORWARD = 'forward',
  CALL = 'call',
  MESSAGE = 'message'
  // GATHER = 'gather'
}
// export interface VoiceNodeCommand_Pause {
//   type: VoiceNodeCommandType.PAUSE
//   seconds: string
// }
export interface VoiceNodeCommand_Hangup {
  type: VoiceNodeCommandType.HANGUP
  message?: string
}
export interface VoiceNodeCommand_Forward {
  type: VoiceNodeCommandType.FORWARD
  to: string
  message?: string
}
export interface VoiceNodeCommand_Call {
  type: VoiceNodeCommandType.CALL
  to: string
  from?: string
}
export interface VoiceNodeCommand_Message {
  type: VoiceNodeCommandType.MESSAGE
  message: string
}

// export interface VoiceNodeCommand_Gather {
//   type: VoiceNodeCommandType.GATHER
//   message?: string
//   brainSlug?: string
//   timeout?: string
//   // numDigits?: string
//   // finishOnKey?: string
//   // type?: string,
//   // language?: string,
// }

export type VoiceNodeCommand =
  // | VoiceNodeCommand_Pause
  | VoiceNodeCommand_Hangup
  | VoiceNodeCommand_Forward
  | VoiceNodeCommand_Call
  | VoiceNodeCommand_Message
// | VoiceNodeCommand_Gather

export interface NodeData_Voice extends NodeInterface {
  id: string
  type: NodeType.Voice
  command: VoiceNodeCommand
  goto?: string
  machineAnsweredGoto?: string
  noAnswerGoto?: string
  timeoutGoto?: string
}
